export const SSN_REGEX =
  /^(000-00-0000)|(?!666|000)\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/;
export const EIN_REGEX = /^[\d]{2}-[\d]{7}$/;
